import { render, staticRenderFns } from "./CoachStatsRow.vue?vue&type=template&id=e8067a84&scoped=true"
import script from "./CoachStatsRow.vue?vue&type=script&lang=js"
export * from "./CoachStatsRow.vue?vue&type=script&lang=js"
import style0 from "./CoachStatsRow.vue?vue&type=style&index=0&id=e8067a84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8067a84",
  null
  
)

export default component.exports